import { ResolvedFlags } from 'navigation/types';

import { InferValueTypes } from 'types/commonTypes';

import * as action from './actions';
import * as actionTypes from './actionTypes';

type ActionType = ReturnType<InferValueTypes<typeof action>>;

export interface FeaturesState {
    /** Resolved Eppo flag values, keyed by flag key. */
    flags: ResolvedFlags;
    /** Server-derived feature toggles from `GET /features`. */
    features: Record<string, boolean>;
    /** True once Eppo flags have been resolved at least once. */
    flagsResolved: boolean;
    /** True once `/features` has resolved (success or fail-closed). */
    featuresLoaded: boolean;
}

const initialState: FeaturesState = {
    flags: {},
    features: {},
    flagsResolved: false,
    featuresLoaded: false,
};

const featuresReducer = (state: FeaturesState = initialState, action: ActionType): FeaturesState => {
    switch (action.type) {
        case actionTypes.SET_FEATURES:
            return { ...state, features: action.payload };

        case actionTypes.SET_FEATURES_LOADED:
            return { ...state, featuresLoaded: action.payload };

        case actionTypes.SET_RESOLVED_FLAGS:
            return { ...state, flags: action.payload, flagsResolved: true };

        default:
            return state;
    }
};

export default featuresReducer;
